import { VEHICLE_TYPES } from "@/lib/constants";

export default function VehicleTypeSelector({ value, onChange }) {
  return (
    <div>
      <label className="block font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted mb-2">
        Type
      </label>
      <div className="flex gap-2">
        {VEHICLE_TYPES.map((t) => {
          const Icon = t.icon;
          const active = value === t.value;
          return (
            <button
              key={t.value}
              type="button"
              onClick={() => onChange(t.value)}
              className={`flex-1 px-3 py-2.5 border text-sm flex items-center justify-center gap-2 transition-colors ${
                active
                  ? "border-ink bg-ink text-white"
                  : "border-canvas-line text-ink hover:border-ink"
              }`}
            >
              <Icon size={14} weight="bold" />
              {t.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
